import type { BusinessReportPrompt } from "@/modules/snapshots/businessReports.types";

export const EMPTY_PROMPT: BusinessReportPrompt = {
  id: "",
  name: "",
  prompt: "",
  created_at: "",
  updated_at: "",
  order: 0,
  full_context: false,
  is_date: false,
  data_type: null,
  use_image: false,
  no_retriever: false,
  web_search: false,
  traffic_light: false,
  auto_refresh_frequency: null,
};

export const AUTO_REFRESH_OPTIONS = [
  { value: "off", label: "Off" },
  { value: "daily", label: "Daily at 06:00 UTC" },
  { value: "weekly", label: "Weekly on Monday at 06:00 UTC" },
  { value: "monthly", label: "Monthly on the 1st at 06:00 UTC" },
] as const;

/** Mirrors MAX_FAMILY_SUMMARY_PROMPT_CHARS in the backend (pf/business_reports/consts.py). */
export const MAX_FAMILY_SUMMARY_PROMPT_CHARS = 50_000;
